import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=02bb3b22&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterModal.vue?vue&type=style&index=0&id=02bb3b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb3b22",
  null
  
)

export default component.exports